import { useCallback } from "react";
import { animate } from "../utils/animation";

export const useAnimation = () => {
  return useCallback((duration, onStep, onEnd = undefined) => {
    return animate({
      duration,
      draw: onStep,
      onEnd,
    });
  }, []);
};
